import React, { useState } from "react";
import { useModalStore } from "../../../stores/modalStore.js";
import { useUserSettingsStore } from "../../../stores/userSettingsStore.js";

export default function SettingsModal() {
  const { isOpen, type, onClose } = useModalStore();
  const { settings, toggleNotification } = useUserSettingsStore();

  if (!isOpen || type !== "settings") return null;

  return (
    <div
      className="modal-overlay fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="modal-content bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg w-96 max-h-96 overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4 border-b border-[#2a2a2a] flex justify-between items-center">
          <h2 className="text-lg font-bold text-white">Settings</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={settings?.notifications?.desktop ?? true}
              onChange={() => toggleNotification?.("desktop")}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-300">Desktop Notifications</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={settings?.notifications?.sound ?? true}
              onChange={() => toggleNotification?.("sound")}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-300">Sound</span>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={settings?.notifications?.mentions ?? true}
              onChange={() => toggleNotification?.("mentions")}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-300">Mentions Only</span>
          </label>
        </div>

        <div className="p-4 border-t border-[#2a2a2a]">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-[#0066ff] hover:bg-[#0052cc] text-white rounded text-sm transition"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
